import ProductList from "../components/ProductList"
import FilterSection from "../components/FilterSection";
import AdminMenu from "./AdminMenu"
import styled from "styled-components"
import PageHeader from "../components/PageCloseButton";

const AdminProduct=()=>{
    return(
        <Wrapper>
            <div className="grid grid-two-column">                
                    <AdminMenu/>
                
                <div className="content">
                    <PageHeader title="Product" />                    
                      <hr />                                     
                    <div>
                    <ProductList/>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

const Wrapper=styled.div`
.grid-two-column{
      display: grid;
      grid-template-columns: 2fr 8fr;
      gap: 2rem;
      }

.content{
      display: block;
      padding: 5rem;    
      }

.filter-product{
    display: flex;
    gap: 3rem;
    }

.filter-clear, .filter-search{
    display : none;
    }

@media (max-width: ${({ theme }) => theme.media.mobile}) {

.grid-two-column{
    grid-template-columns:1fr;
    }
.content{
    padding: 1rem;    
      }
}
`;
export default AdminProduct